module.exports = __webpack_public_path__ + "img/hide-comment.0e3fe4cb.svg";